import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { Mutation, MutationDeleteAreaCoverageArgs } from "@hubcapp/types";

import { DeepPartial } from "types";
import deleteAreaMutation from "../graph-ql/deleteArea.graphql";

const useMutationDeleteArea = (
  opts: MutationHookOptions<
    DeepPartial<Mutation>,
    MutationDeleteAreaCoverageArgs
  > = {},
) => useMutation(deleteAreaMutation, opts);

export default useMutationDeleteArea;
